module.exports = __webpack_public_path__ + "img/photo.15b99272.png";